(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9593],{

/***/ 36093:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/contracts/[category]",
      function () {
        return __webpack_require__(68620);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2208);
/* harmony import */ var _components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7041);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10447);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56475);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69274);











const StickyLoginCard = (param)=>{
    let { pageProduct ="" , cardWidth ="xs:w-[360px]" , title , description  } = param;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
    const content = {
        default: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        approvals: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your approval workflows.",
            link: "https://approval-dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        signature: {
            title: "Tired of nonsense pricing of DocuSign?",
            description: "Start taking digital signatures with BoloSign and save money.",
            link: "https://signature.boloforms.com/register?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        "timer-proctor": {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating tests using BoloForms Timer + Proctor.",
            link: "https://dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        sheetgod: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start enhancing your sheets using BoloForms SheetGod.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        taxes: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__/* .createUTMQueryParams */ .T0)({
                utmData_: context.globalData.utmData,
                from: "STICKY_CARD"
            }))
        }
    };
    const contentToDisplay = pageProduct && content[pageProduct] ? content[pageProduct] : content.signature;
    return(//   <div className="max-w-screen-mxl mx-auto">
    //   {
    //     <FeatureCards
    //       cardsData={featuresData}
    //       featuresStyling={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10`}
    //     />
    //   }
    //   <div className="mt-10 flex justify-center items-center">
    //     <ButtonPrimary buttonText={`All Features`} buttonUrl={`#`} />
    //   </div>
    // </div>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full ".concat(cardWidth, " mx-auto border border-surface-dark  px-6 pt-7 pb-9 flex flex-col gap-4 text-center justify-center items-center rounded-xl bg-surface"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/boloforms-signature/boloforms-logo.png"),
                className: "w-auto h-auto rounded-full",
                width: 10,
                height: 10,
                alt: "BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl",
                        children: title ? title : contentToDisplay.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray-600",
                        children: description ? description : contentToDisplay.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMButtonPrimary */ .IS, {
                            buttonText: "Get started for free",
                            buttonUrl: contentToDisplay.link,
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__/* .HiArrowLongRight */ .P8b, {})
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyLoginCard);


/***/ }),

/***/ 7041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatureCards = (param)=>{
    let { cardsData , cardsStyling =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8",
        children: cardsData.map((card, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-6 border-2 px-6 sm:px-10 pb-10 pt-16 rounded-xl cardBorders transition-all duration-500 ease-in-out border-gray-600 text-center ".concat(card.styling),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-[100px] h-[100px] mx-auto",
                        children: card.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-5xl lg:text-5xl flex justify-center items-center h-full w-full bg-white rounded-full",
                            children: card.icon
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-2xl font-bold",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-xl",
                                children: card.description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureCards);


/***/ }),

/***/ 68620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86893);
/* harmony import */ var react_loader_spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62194);
/* harmony import */ var components_StickyLoginCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46591);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56475);












// remove hyphen from url and capitalize first letter of each word
const removeHyphenAndCapitalize = (str)=>{
    return str.replace(/-/g, " ").replace(/\w\S*/g, (w)=>w.replace(/^\w/, (c)=>c.toUpperCase()));
};
const addHyphenInUrl = (str)=>{
    return str.replace(/\s+/g, "-").toLowerCase();
};
const Category = (param)=>{
    let { title , description , groupedContracts  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { category  } = router.query;
    const [search, setSearch] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [searchLoading, setSearchLoading] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    const [searchResults, setSearchResults] = react__WEBPACK_IMPORTED_MODULE_2__.useState([]);
    const [activeSection, setActiveSection] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const handleScroll = ()=>{
        const scrollPosition = window.scrollY;
        const activeSection = Object.keys(groupedContracts).find((subCategory)=>{
            const sectionElement = document.getElementById(addHyphenInUrl(subCategory));
            if (sectionElement) {
                const sectionTop = sectionElement.offsetTop;
                const sectionBottom = sectionTop + sectionElement.offsetHeight;
                return scrollPosition >= sectionTop && scrollPosition < sectionBottom;
            }
            return false;
        });
        setActiveSection(activeSection || "");
    };
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        category
    ]);
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        const handleSearch = async ()=>{
            // console.log("searching");
            setSearchLoading(true);
            const response = await fetch("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_URL_POST, "search-contracts"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    searchQuery: search
                })
            });
            const data = await response.json();
            const { contracts  } = data;
            setSearchResults(contracts);
            setSearchLoading(false);
        };
        let timer = setTimeout(()=>{
            if (search.length > 0) {
                handleSearch();
            } else {
                setSearchResults([]);
            }
        }, 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        search
    ]);
    const bgColors = [
        "bg-green-100/50",
        "bg-yellow-100/50",
        "bg-red-100/50",
        "bg-gray-100/50",
        "bg-blue-100/50",
        "bg-purple-100/50",
        "bg-indigo-100/50"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            "Download ",
                            removeHyphenAndCapitalize(category),
                            " Documents | BoloSign"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Get all the Legal documents for ".concat(removeHyphenAndCapitalize(category), ", use them as you like, download, modify and send for signing using BoloSign")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: " "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/contracts/".concat(category, "/")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Get all the Legal documents for ".concat(removeHyphenAndCapitalize(category), ", use them as you like, download, modify and send for signing using BoloForms")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/contracts/".concat(category, "/")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Get all the Legal documents for ".concat(removeHyphenAndCapitalize(category), ", use them as you like, download, modify and send for signing using BoloForms")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/contracts/".concat(category, "/")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full max-w-screen-xl mx-auto flex flex-col scroll-smooth px-4 md:px-8 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-3xl lg:text-5xl lg:leading-[55px] font-bold text-gray-800 text-center",
                                children: category && removeHyphenAndCapitalize(category)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-screen-md mx-auto flex flex-col mt-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex justify-between items-center md:gap-2 w-full h-[50px] sm:h-[60px] p-2 rounded-lg bg-white border-[2px] border-gray-800",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-gray-800 text-3xl pl-3",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_10__/* .FiSearch */ .jRj, {})
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                value: search,
                                                onChange: (e)=>setSearch(e.target.value),
                                                placeholder: "Search for a document",
                                                className: "h-full w-full px-3 md:flex-1 text-xl text-gray-800 placeholder-gray-800 outline-none border-none",
                                                name: "",
                                                id: ""
                                            }),
                                            searchLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-gray-400",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loader_spinner__WEBPACK_IMPORTED_MODULE_7__/* .ThreeDots */ .g4, {
                                                    height: "40",
                                                    width: "50",
                                                    radius: "9",
                                                    color: "#a070f2",
                                                    ariaLabel: "three-dots-loading",
                                                    wrapperStyle: {},
                                                    wrapperClassName: "",
                                                    visible: true
                                                })
                                            })
                                        ]
                                    }),
                                    searchResults.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "border-2 rounded-lg bg-white mx-auto w-full mt-5 max-h-[480px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-corner-white scrollbar-track-transparent drop-shadow-xl ",
                                        children: searchResults.map((contract, index)=>{
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "/signature/contracts/".concat(addHyphenInUrl(contract === null || contract === void 0 ? void 0 : contract.categories), "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug),
                                                className: "w-full group flex flex-col hover:bg-gray-50",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full text-left md:px-6 md:pt-6 px-4 pt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                className: "text-gray-700 text-xl font-semibold leading-snug",
                                                                children: contract === null || contract === void 0 ? void 0 : contract.name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "font-normal text-base text-gray-700",
                                                                children: contract === null || contract === void 0 ? void 0 : contract.description
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-full flex justify-end items-center pr-4 border-b border-gray-200 pb-4",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMLinkPrimaryArrow */ .c$, {
                                                            buttonText: "Create Document",
                                                            buttonUrl: "/signature/contracts/".concat(addHyphenInUrl(contract === null || contract === void 0 ? void 0 : contract.categories), "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug)
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-gray-800 text-md sm:text-lg max-w-screen-lg mx-auto text-center mt-6 sm:mt-8 ".concat(searchResults.length > 0 ? "hidden" : "visible"),
                                children: "Whether you're starting a business, building an empire, or have\n            business-related administration to carry out, we're here to help with\n            our range of professional business contracts. From LLC agreements to\n            NDAs, we've got the legal documents you need to make your day-to-day\n            easier. Explore our business legal documents, forms, and contracts\n            below."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full flex justify-between flex-col lg:flex-row gap-12 xl:gap-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[250px] h-fit border-l-2 border-l-gray-700 lg:sticky top-[120px] lg:mt-[112px]",
                                children: Object.keys(groupedContracts).map((subCategory, index)=>{
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "#".concat(addHyphenInUrl(subCategory)),
                                        // id={removeHyphenAndCapitalize(subCategory)}
                                        className: "text-md font-semibold py-4 px-4 block ".concat(activeSection === subCategory ? "bg-black text-white" : "text-black hover:text-violet-500"),
                                        onClick: (e)=>{
                                            var _addHyphenInUrl;
                                            e.preventDefault();
                                            document.querySelector("#".concat((_addHyphenInUrl = addHyphenInUrl(subCategory)) === null || _addHyphenInUrl === void 0 ? void 0 : _addHyphenInUrl.replace(/&/g, "\\&"))).scrollIntoView({
                                                behavior: "smooth"
                                            });
                                        },
                                        children: subCategory
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-10 flex-1",
                                children: groupedContracts && Object.keys(groupedContracts).map((subCategory, index)=>{
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        id: addHyphenInUrl(subCategory),
                                        className: "flex flex-col gap-10 pt-[112px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "text-3xl md:text-4xl px-2 mt-4 font-semibold bg-white text-black rounded-t-xl",
                                                    children: subCategory
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4",
                                                    children: groupedContracts[subCategory].map((contract, index)=>{
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                            href: "/signature/contracts/".concat(category, "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug),
                                                            className: "w-full group flex flex-col hover:bg-surface-light bg-surface md:p-6 p-4 border border-gray-200 transition-all duration-500 ease-in-out md:rounded-2xl rounded-xl gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "flex-1 flex flex-col gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                            className: "text-gray-800 text-xl font-bold",
                                                                            children: contract === null || contract === void 0 ? void 0 : contract.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                            className: "font-normal text-md text-gray-800",
                                                                            children: contract === null || contract === void 0 ? void 0 : contract.description
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "w-full flex justify-start items-center pr-4 ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMLinkPrimaryArrow */ .c$, {
                                                                        buttonText: "Create Document",
                                                                        buttonUrl: "/signature/contracts/".concat(category, "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug)
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Category);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(36093); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);